/**
 * Single builder for every wa.me link on the site.
 *
 * When the CTW feature is enabled and a source code is cached, the code is
 * embedded in the message as an invisible run (see ./token.ts). When the
 * feature is off or no code exists, output is byte-identical to the legacy
 * `https://wa.me/<phone>?text=<encoded message>` template.
 */

import { getCachedCtwCode } from "./mintClient";
import { injectToken } from "./token";

export function buildWaLink(phoneNumber: string, message: string): string {
  const code = getCachedCtwCode();
  const text = code ? injectToken(message, code) : message;
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
}
